
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Kaum ist das Mittagessen verdrückt, ist sie da: die grosse Mittagsmüdigkeit, das «Suppenkoma». Wäre es nun sinnvoll, sich kurz hinzulegen? Wer sich danach erfrischt fühlt und nachts gut schlafen kann, dem dürfte ein Mittagsschlaf Energie für die zweite Tageshälfte geben, so der Medizinische Psychologe Albrecht Vorster. Zudem kann ein Nickerchen die Muskeln entspannen und Stress lösen – zumindest kurzfristig. Wichtig ist auch hier, dass der Wecker nach spätestens 20 Minuten klingelt. Ansonsten schlummert man in eine Tiefschlafphase hinein und der gewünschte Energieschub bleibt weg. Insomnie-Kranke sollten auf das Powernapping am Mittag aber ganz verzichten – es brächte ihren Schlafrhythmus zusätzlich durcheinander.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;